<template>
	<v-container fluid>
		<v-layout row wrap>
			<v-flex xs12>
				<span style="display:inline-block; padding:10px; margin-top:5px; color:grey; font-size:15px;"><b>{{$t('labels.reports')}}</b></span><br><br>
			</v-flex>
			<v-flex xs12 pt-2>
				<v-btn color="grey lighten-1" @click="reroute('contacts')" style="width:30%">
					{{ $t('buttons.contactReport') }}
				</v-btn><br>
			</v-flex>
			<v-flex xs12 pt-2>
				<v-btn color="grey lighten-1" @click="reroute('realestate')" style="width:30%">
					{{ $t('buttons.realestateReport') }}
				</v-btn>
			</v-flex>
			<v-flex xs12 pt-2>
				<v-btn color="grey lighten-1" @click="reroute('opportunity-questionnaire')" style="width:30%">
					{{ $t('buttons.opportunityQuestionnaireReport') }}
				</v-btn>
			</v-flex>
			<v-flex xs12 pt-2>
				<v-btn color="grey lighten-1" @click="reroute('opportunity-buyer')" style="width:30%">
					{{ $t('buttons.opportunityBuyerReport') }}
				</v-btn>
			</v-flex>
			<v-flex xs12 pt-2>
				<v-btn color="grey lighten-1" @click="reroute('realestate-analysis')" style="width:30%">
					{{ $t('buttons.realestateAnalysisReport') }}
				</v-btn>
			</v-flex>
			<v-flex xs12 pt-2>
				<v-btn color="grey lighten-1" @click="reroute('contacts-analysis')" style="width:30%">
					{{ $t('buttons.contactsAnalysisReport') }}
				</v-btn>
			</v-flex>
			<v-flex xs12 pt-2>
				<v-btn color="grey lighten-1" @click="reroute('partners')" style="width:30%">
					{{ $t('buttons.partnersReport') }}
				</v-btn>
			</v-flex>
			<v-flex xs12 pt-2>
				<v-btn color="grey lighten-1" @click="reroute('partners-realestate')" style="width:30%">
					{{ $t('buttons.partnersRealestateReport') }}
				</v-btn>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
import DataTable from "./trinkets/DataTable";

export default {
	name: "Locations",
	components: {DataTable},
	data: function () {
		return {

		}
	},
	methods: {
		reroute(location){
			this.$router.push('/reports/' + location);
		}
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('login');
		}
		this.$setSubMenu('Settings');
		this.$myStore.commit('setBreadcrumbs', [
			{text: this.$t('modules.reports'), href: '/#/reports', disabled: true}
		]);
	}
}
</script>

<style scoped>

</style>
